import classNames from 'classnames';
import cs from '../application-details.module.scss';
import { Checkbox, fontStyles } from '@monash/portal-react';
import { Controller } from 'react-hook-form';

const DISCOVERY_METHOD_ID = {
  PAST_PARTICIPANT: 'PAST_PARTICIPANT',
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
  EMAIL: 'EMAIL',
  FRIEND: 'FRIEND',
  WEBSITE: 'WEBSITE',
  INTERNET_SEARCH: 'INTERNET_SEARCH',
};

const CHECKBOX_OPTIONS = [
  { id: DISCOVERY_METHOD_ID.PAST_PARTICIPANT, text: 'Past participant' },
  {
    id: DISCOVERY_METHOD_ID.SOCIAL_MEDIA,
    text: 'Socials: LinkedIn, TikTok, Instagram',
  },
  { id: DISCOVERY_METHOD_ID.EMAIL, text: 'Email from Monash' },
  { id: DISCOVERY_METHOD_ID.FRIEND, text: 'Friend' },
  { id: DISCOVERY_METHOD_ID.WEBSITE, text: 'Website' },
  { id: DISCOVERY_METHOD_ID.INTERNET_SEARCH, text: 'Internet search' },
];

const DiscoveryMethodFields = () => {
  return (
    <div className={cs.fieldWrapper}>
      <div
        className={classNames(
          fontStyles.heading,
          fontStyles.sm,
          fontStyles.medium
        )}
      >
        How did you hear about PASS?
        <span className={cs.required}>*</span>
      </div>
      <div>
        {CHECKBOX_OPTIONS.map((option) => {
          const { id: optionId, text } = option;
          return (
            <Controller
              key={optionId}
              name="discoveryMethods"
              rules={{
                validate: (value) =>
                  value?.length >= 1 || 'Select at least one method',
              }}
              render={({ field: { value, onChange } }) => (
                <Checkbox
                  text={text}
                  on={value.includes(optionId)}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    const next = checked
                      ? [...value, optionId]
                      : value.filter((id) => id !== optionId);
                    onChange(next);
                  }}
                />
              )}
            />
          );
        })}
      </div>
    </div>
  );
};

export default DiscoveryMethodFields;
